import { createContext, useContext, useState, useEffect } from "react";
import { axiosAuth } from "../api/axiosConfig";
import { useUserContext } from "./UserContext";

const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const [selectedCustomer, setSelectedCustomer] = useState({
    customer: "Admin",
  });
  const [customers, setCustomers] = useState([]);
  const { user } = useUserContext();

  useEffect(() => {
    const storedCustomer = localStorage.getItem("selectedCustomer");
    if (storedCustomer) {
      setSelectedCustomer(JSON.parse(storedCustomer));
    }
  }, []);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const { data } = await axiosAuth.get("/admin/get-all-customers");
        // A bare array is the server's shape before API Contract #7, kept
        // for the deploy window where client and server can briefly
        // mismatch; drop the fallback in API Contract #8.
        setCustomers(Array.isArray(data) ? data : data.customers);
      } catch (err) {
        console.error("Error fetching customers:", err);
      }
    };

    if (user && user.role === "admin") {
      fetchCustomers();
    }
  }, [user]);

  const updateSelectedCustomer = (customer) => {
    setSelectedCustomer(customer);
    localStorage.setItem("selectedCustomer", JSON.stringify(customer));
  };

  return (
    <AdminContext.Provider
      value={{
        selectedCustomer,
        updateSelectedCustomer,
        customers,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
export const useAdminContext = () => {
  return useContext(AdminContext);
};
